/**
 * @file
 * A JavaScript file for the site.
 *
 * @copyright Copyright 2019 Palantir.net
 */

// JavaScript should be made compatible with libraries other than jQuery by
// wrapping it with an "anonymous closure". See:
// - https://drupal.org/node/1446420
// - http://www.adequatelygood.com/2010/3/JavaScript-Module-Pattern-In-Depth

(function ($) {

  // Add class once page content fully loads
  $(window).on('load', function() {
    $('html').addClass('js-content-loaded');
  });

  // Add class to header on scroll
  $(window).scroll(function() {
    var scroll = $(window).scrollTop();

    if (scroll >= 100) {
      $('.site-header').addClass('js-scroll');
    } else {
      $('.site-header').removeClass('js-scroll');
    }
  });

  $(document).ready(function() {

    // Mobile menu trigger
    $('.brand__hamburger, .overlay').on('click', function() {
      if ($(this).hasClass('open')) {
        $('.site-header__mobile-menus, .overlay, .brand__hamburger').removeClass('open');
        $('.js-brand__hamburger-label').text("Menu");
      } else {
        $('.site-header__mobile-menus, .overlay, .brand__hamburger').addClass('open');
        $('.js-brand__hamburger-label').text("Close");
      }
    });

    // Mobile second level trigger
    $('.mobile-menu__drawer').on('click', function() {
      if ($(this).hasClass('open')) {
        $(this).removeClass('open').attr('aria-expanded', 'false');
        $(this).next('.mobile-menu__secondar-level').slideUp();
      } else {
        $('.mobile-menu__drawer').removeClass('open').attr('aria-expanded', 'false');
        $('.mobile-menu__secondar-level').slideUp();
        $(this).addClass('open').attr('aria-expanded', 'true');
        $(this).next('.mobile-menu__secondar-level').slideDown();
      }
    });

    // Main menu trigger on click
    $('.main-menu__parent-link').on('click', function(event) {
      event.preventDefault();
      if ($(this).parent('.main-menu__parent').hasClass('open')) {
        $('.main-menu__parent').removeClass('open');
        $('.main-menu__parent .main-menu__parent-link').attr('aria-expanded', 'false');
        $(this).parent('.main-menu__parent').removeClass('open');
        $(this).attr('aria-expanded', 'false');
      } else {
        $('.main-menu__parent').removeClass('open');
        $('.main-menu__parent .main-menu__parent-link').attr('aria-expanded', 'false');
        $(this).parent('.main-menu__parent').addClass('open');
        $(this).attr('aria-expanded', 'true');
      }
    });

    // Close dropdown with last item
    $('.main-menu__close-dropdown').on('click focusout', function(event) {
      event.preventDefault();
      $('.main-menu__parent').removeClass('open');
      $('.main-menu__parent .main-menu__parent-link').attr('aria-expanded', 'false');
    });

    $(window).click(function(e) {
      // If user clicks inside of main menu partent, do nothing
      if( $(e.target).closest('.main-menu__parent').length === 0 ) {
        // Hide flyout when users clicks outside of flyout
        $('.main-menu__parent').removeClass('open');
        $('.main-menu__parent .main-menu__parent-link').attr('aria-expanded', 'false');
      }
    });
  });

  // width at which we switch from mobile menu to regular sidenav
  const menuSwitch = 900;
  // Get the window width - used to determine mobile vs. desktop.
  function getWindowWidth() {
    const width = $( window ).width();
    return width;
  }
  let windowWidth = getWindowWidth();
  let mobile = true;

  // Hide secondary Header on on scroll down
  // @todo abstract this out to support hierarchy of multiple navs so it will not conflict
  //  with main nav, refactor to work without jQuery. Move all or component-specific parts
  //  to separate component js file.
  let didScroll;
  let lastScrollTop = 0;
  let delta = 5;
  const secondaryHeader = document.querySelector('.js-navigation-secondary');
  const anchorContent = document.querySelector('.js-anchor-nav__content');
  let navbaroffset = 0;
  let navbarHeight = 0;
  if (secondaryHeader) {
    navbarHeight = secondaryHeader.offsetHeight;
    navbaroffset = secondaryHeader.getBoundingClientRect().top;
  }

  $(window).resize(function () {
    windowWidth = getWindowWidth();
    if (windowWidth > menuSwitch) {
      mobile = false;
      if (secondaryHeader) {
        secondaryHeader.classList.remove('nav-show');
      }
      if (anchorContent) {
        anchorContent.style.paddingTop = '0px';
      }
    } else {
      mobile = true;
    }
  });

  $(window).scroll(function(event){
    windowWidth = getWindowWidth();
    if (windowWidth > menuSwitch) {
      mobile = false;
      if (secondaryHeader) {
        secondaryHeader.classList.remove('nav-show');
      }
      if (anchorContent) {
        anchorContent.style.paddingTop = '0px';
      }
    }
    didScroll = true;
  });


  function hasScrolled() {
    let st = $(this).scrollTop();
    // Make sure they scroll more than delta
    if(Math.abs(lastScrollTop - st) <= delta)
      return;
    let aboveheight = navbarHeight + navbaroffset;
    // If they scrolled down and are past the navbar, add class .nav-up.
    // This is necessary so you never see what is "behind" the navbar.
    if (st > lastScrollTop && st > aboveheight) {
      // Scroll Down
      if (secondaryHeader) {
        secondaryHeader.classList.remove('nav-show');
      }
      if (anchorContent) {
        anchorContent.style.paddingTop = '0px';
      }
    } else {
      if (st < lastScrollTop) {
        if (st < aboveheight) {
          // Scroll up past top of content.
          if (secondaryHeader) {
            secondaryHeader.classList.remove('nav-show');
          }
          if (anchorContent) {
            anchorContent.style.paddingTop = '0px';
          }
        } else {
          // scroll up
          if (secondaryHeader) {
            secondaryHeader.classList.add('nav-show');
          }
          if (anchorContent) {
            anchorContent.style.paddingTop = navbarHeight + 'px';
          }
        }
      }
    }
    lastScrollTop = st;
  }

  setInterval(function() {
    if (didScroll && mobile) {
      hasScrolled();
      didScroll = false;
    }
  }, 250);

})(jQuery);
